import React, { createContext, useContext, useState, useEffect } from "react";
import getRole from "../services/RoleService";
import getRoutes from "../router";
const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [appRoutes, setAppRoutes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      const role = await getRole();
      const loggedIn = role.roles ? true : false;
      setIsLoggedIn(loggedIn);
      setAppRoutes(getRoutes(loggedIn));
      setLoading(false);
    };
    checkAuth();
  }, []);

  const login = (token, remember) => {
    localStorage.setItem("accessToken", JSON.stringify(token));
    localStorage.setItem("REMEMBERME", JSON.stringify(remember));
    sessionStorage.setItem("isLogin", JSON.stringify(true));
    setIsLoggedIn(true);
    setAppRoutes(getRoutes(true));
  };

  const logout = () => {
    setIsLoggedIn(false);
    sessionStorage.clear();
    localStorage.clear();
    setAppRoutes(getRoutes(false));
  };

  if (loading) {
    return <div>Loading...</div>; // Or a loading spinner
  }

  return (
    <AuthContext.Provider value={{ isLoggedIn, login, logout, appRoutes }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}
